import axios from 'axios';
import sesionService from '@/services/SesionService';

export default {
	async getAll() {
		const HEADER = await sesionService.getHeader();
		if (HEADER !== '') {
			try {
				let res = await axios.get('/data/all', HEADER);
				return res.data;
			} catch (error) {
				console.log(error);
			}
		}
	},

	async getAllForSelect(query) {
		const HEADER = await sesionService.getHeader();
		if (HEADER !== '') {
			try {
				let res = await axios.get(`/data/for-select?query=${query}`, HEADER);
				return res.data;
			} catch (error) {
				console.log(error);
			}
		}
	},

	async getChildAvailablesData(id) {
		const HEADER = await sesionService.getHeader();
		if (HEADER !== '') {
			try {
				let res = await axios.get(`/child/data/${id}`, HEADER);
				return res.data;
			} catch (error) {
				console.log(error);
			}
		}
	},

	async getFamilyUnsignedData(id) {
		const HEADER = await sesionService.getHeader();
		if (HEADER !== '') {
			try {
				let res = await axios.get(`/family/data/${id}`, HEADER);
				return res.data;
			} catch (error) {
				console.log(error);
			}
		}
	},

	async getDataById(id) {
		const HEADER = await sesionService.getHeader();
		if (HEADER !== '') {
			try {
				let res = await axios.get(`/data/${id}`, HEADER);
				return res.data;
			} catch (error) {
				console.log(error);
			}
		}
	},

	async saveDataElement(dataElement) {
		const HEADER = await sesionService.getHeader();
		if (HEADER !== '') {
			let {
				name,
				description,
				category,
				subcategory,
				class: classElement,
				dataType,
				compositeData,
				isCompositeData
			} = dataElement;
			try {
				let res = await axios.post(
					'/data',
					{
						name,
						description,
						category,
						subcategory,
						class: classElement,
						dataType,
						compositeData,
						isCompositeData
					},
					HEADER
				);
				return res.data;
			} catch (error) {
				console.log(error);
			}
		}
	},

	async updateDataElement(dataElement) {
		const HEADER = await sesionService.getHeader();
		if (HEADER !== '') {
			let {
				name,
				description,
				category,
				subcategory,
				class: classElement,
				dataType,
				_id,
				notifications
			} = dataElement;
			try {
				let res = await axios.put(
					`/data/${_id}`,
					{
						name,
						description,
						category,
						subcategory,
						class: classElement,
						dataType,
						notifications
					},
					HEADER
				);
				return res.data;
			} catch (error) {
				console.log(error);
			}
		}
	}
};
